<template>
  <searchable-object-selector ref="selector" :objects="sortedPeople" :disabled="disabled" :placeholder="placeholder"
    @input="input" :loading="loading" :formatter="formatter" :value="value" />
</template>

<script>
export default {
  name: 'staff-selector',
  props: {
    value: Object,
    allowNull: {
      Boolean,
      default() {
        return false;
      }
    },
    disabled: {
      Boolean,
      default() {
        return false;
      }
    },
    size: String,
    placeholder: String
  },
  data: () => ({
    loading: false,
    people: []
  }),
  computed: {
    sortedPeople() {
      return this.people.slice().sort((a, b) => a.last_name.localeCompare(b.last_name));
    }
  },
  methods: {
    async reload() {
      this.loading = true;
      try {
        this.people = await ArcAPI.people.list_in_role("staff");
      } catch (error) {
        Notify.displayAPIError(error);
      } finally {
        this.loading = false;
      }
    },
    input(v) {
      this.$emit('input', v);
    },
    selectById(id) {
      this.$refs.selector.selectById(id);
    },
    formatter(o) {
      return `${o.name} (${o.email_address})`;
    }
  },
  mounted() {
    this.reload();
  }
};
</script>
